import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Plus, Save, Trash } from "lucide-react";
import { ImageUpload } from "@/components/ImageUpload";

export default function AdminBlog() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = useCallback(async () => { const { data } = await api.get("/blog"); setItems(data); }, []);
  useEffect(() => { load(); }, [load]);

  const startNew = () => setEditing({ __new: true, title: "", slug: "", excerpt: "", content: "", cover_image: "", category: "Genel", author: "Malatya Mobilya", seo_title: "", seo_description: "", published: true });

  const save = async () => {
    const body = { ...editing }; delete body.__new; delete body.id;
    try {
      if (editing.__new) { await api.post("/blog", body); toast.success("Eklendi"); }
      else { await api.put(`/blog/${editing.id}`, body); toast.success("Güncellendi"); }
      setEditing(null); load();
    } catch { toast.error("Hata"); }
  };

  const del = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/blog/${id}`); toast.success("Silindi"); load();
  };

  return (
    <div data-testid="admin-blog">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-display text-3xl md:text-4xl font-black text-ink-900">Blog Yazıları</h1>
        <Button onClick={startNew} className="gradient-primary text-white rounded-full"><Plus className="h-4 w-4 mr-1" /> Yeni Yazı</Button>
      </div>
      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 rounded-3xl bg-white border border-ink-100 overflow-hidden">
          <table className="min-w-full text-sm">
            <thead className="bg-ink-50"><tr>
              <th className="text-left px-4 py-3 font-semibold">Başlık</th>
              <th className="text-left px-4 py-3 font-semibold">Kategori</th>
              <th className="text-left px-4 py-3 font-semibold">Yayında</th>
              <th></th>
            </tr></thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id} onClick={() => setEditing({ ...it })} className={`border-t border-ink-100 cursor-pointer hover:bg-brand-50/30 ${editing?.id === it.id ? "bg-brand-50/60" : ""}`}>
                  <td className="px-4 py-3"><div className="font-semibold">{it.title}</div><div className="text-xs text-ink-500">{it.slug}</div></td>
                  <td className="px-4 py-3">{it.category}</td>
                  <td className="px-4 py-3">{it.published ? "✅" : "-"}</td>
                  <td className="px-4 py-3 text-right"><button onClick={(e) => { e.stopPropagation(); del(it.id); }} className="text-red-500"><Trash className="h-4 w-4" /></button></td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={4} className="py-8 text-center text-ink-500">Yazı yok.</td></tr>}
            </tbody>
          </table>
        </div>
        <div className="rounded-3xl bg-white border border-ink-100 p-6">
          {editing ? (
            <div className="space-y-4">
              <h3 className="font-display font-bold text-xl">{editing.__new ? "Yeni Yazı" : "Düzenle"}</h3>
              {[
                ["title", "Başlık"], ["slug", "Slug"],
                ["category", "Kategori"], ["author", "Yazar"], ["seo_title", "SEO Başlık"], ["seo_description", "SEO Açıklama"],
              ].map(([k, l]) => (
                <div key={k}><Label className="text-xs uppercase tracking-widest font-bold">{l}</Label>
                  <Input value={editing[k] || ""} onChange={(e) => setEditing({ ...editing, [k]: e.target.value })} className="mt-1.5" /></div>
              ))}
              <ImageUpload
                value={editing.cover_image || ""}
                onChange={(url) => setEditing({ ...editing, cover_image: url })}
                label="Kapak Görseli"
                testId="blog-cover-image"
              />
              <div><Label>Özet</Label><Textarea rows={2} value={editing.excerpt || ""} onChange={(e) => setEditing({ ...editing, excerpt: e.target.value })} className="mt-1.5" /></div>
              <div><Label>İçerik (HTML)</Label><Textarea rows={8} value={editing.content || ""} onChange={(e) => setEditing({ ...editing, content: e.target.value })} className="mt-1.5 font-mono text-xs" /></div>
              <div className="flex items-center gap-3"><Switch checked={!!editing.published} onCheckedChange={(v) => setEditing({ ...editing, published: v })} /><span className="text-sm">Yayında</span></div>
              <div className="flex gap-2 pt-2">
                <Button onClick={save} className="gradient-primary text-white rounded-full"><Save className="h-4 w-4 mr-1.5" /> Kaydet</Button>
                <Button variant="outline" onClick={() => setEditing(null)} className="rounded-full">İptal</Button>
              </div>
            </div>
          ) : <div className="text-ink-500 text-sm">Yazı seçin veya yeni ekleyin.</div>}
        </div>
      </div>
    </div>
  );
}
